import * as Api from '@ViewModels';
import { useQuery } from '@tanstack/react-query';
import { reactQueryClient } from '../../web/ReactQueryProvider';
import { useUserSession } from '../../models/hooks/appStateHooks';

const BASE_QUERY_KEY = 'note';

/**
 * Fetches a single note by id (`GET note/{id}`). No impersonation — note reads are scoped
 * server-side. Disabled when `id` is empty so callers can pass an optional account note id
 * directly. Returns the full `Api.INote` (carrying `content`, `creator`, `lastModifiedDate`,
 * `preview`) for read-only display.
 */
export function useNoteByIdQuery(id: string | undefined | null) {
	const userSession = useUserSession();
	return useQuery<Api.INote>({
		enabled: !!id,
		queryFn: () => userSession.webServiceHelper.callAsync<Api.INote>(`note/${id}`, 'GET'),
		queryKey: [BASE_QUERY_KEY, id],
	});
}

export const invalidateNoteById = (id: string | undefined | null) => {
	if (!id) {
		return;
	}
	reactQueryClient.invalidateQueries({ queryKey: [BASE_QUERY_KEY, id] });
};
